module.exports = __webpack_public_path__ + "static/img/1.30a3132.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/preview/department/1.png
// module id = NZRH
// module chunks = 1